/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBlockLines: {
  name: 'block-lines';
  data: string;
} = {
  name: 'block-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2Zm1 9v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-3h-13Zm13-1h-13V6h13v4Zm0-8v3h-13V2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
